// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from '/root/workspace/__flow_work/__flow_builds/ec282803-2994-456e-8efd-ffe83d502e81/workspace/ace-client/node_modules/.pnpm/@umijs+renderer-react@4.4.12_nnrd3gsncyragczmpvfhocinkq/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
